import React, { useState, useEffect } from 'react';
import './EarningsManagement.css'; // Include the CSS for styling
import { FaSearch, FaFilter, FaFileExcel } from 'react-icons/fa'; // Import icons for search, filter
import axios from '../../../axiosInstance'; // Import Axios for API requests
import Sidebar_admin from '../Sidebar_Admin/Sidebar_admin';
import * as XLSX from 'xlsx'; // Import XLSX for exporting Excel


const EarningsManagement = () => {
  const [monthlyData, setMonthlyData] = useState([]); // Store monthly earnings data
  const [filteredData, setFilteredData] = useState([]); // Store filtered data
  const [searchQuery, setSearchQuery] = useState(''); // Store search query
  const [selectedMonth, setSelectedMonth] = useState('All'); // Month filter
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(''); // Error state
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year

  // Function to get the current month in the required format (e.g., "January 2024")
  const getCurrentMonth = () => {
    const now = new Date();
    const options = { month: 'long', year: 'numeric' };
    return now.toLocaleDateString('en-US', options); // Returns like "December 2024"
  };

  // Fetch earnings data based on reporterId and month
  const fetchEarningsData = async (reporterId, year, month) => {
    try {
      setLoading(true);
      const response = await axios.get('/api/news/earnings', {
        params: { reporterId, year, month }
      });
      setFilteredData(response.data); // Set the filtered data directly from API response
      setLoading(false);
    } catch (err) {
      setError('Error fetching data'); // Set error state on failure
      setLoading(false);
    }
  };
  

  // Fetch current month data when the component mounts
  useEffect(() => {
    const currentMonth = getCurrentMonth();
    fetchEarningsData('', currentMonth); // Pass empty string for reporterId to get all reporters for the current month
  }, []);

  // Handle search query change
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // Fetch data if search query is not empty
    if (query) {
      fetchEarningsData(query, selectedMonth !== 'All' ? selectedMonth : '');
    } else {
      fetchEarningsData('', selectedMonth !== 'All' ? selectedMonth : ''); // Clear search, but keep month filter
    }
  };

  // Handle month filter change
  const handleYearFilterChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    fetchEarningsData(searchQuery, year, selectedMonth !== 'All' ? selectedMonth : '');
  };
  
  const handleMonthFilterChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    fetchEarningsData(searchQuery, selectedYear, month !== 'All' ? month : '');
  };
  
  // Calculate total earnings based on views (0.07 INR per view)
  const calculateEarnings = (views) => {
    return (views * 0.07).toFixed(2); // 0.07 INR per view
  };




    // Export to Excel function
    const exportToExcel = () => {
      // Create worksheet from filtered views data
      const ws = XLSX.utils.json_to_sheet(filteredData);
  
      // Create a new workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Views Data');
  
      // Generate Excel file and trigger the download
      XLSX.writeFile(wb, 'views_data.xlsx');
    };
  

  return (
    <div>
      <Sidebar_admin />
      <div className="earnings-management">
        <h2 className="earnings-management__title">Earnings Management</h2>

        {/* Search and Filter Section */}
        <div className="earnings-management__search-filter">
  <div className="earnings-management__search">
    <input
      type="text"
      placeholder="Search by Reporter ID..."
      value={searchQuery}
      onChange={handleSearch}
      className="earnings-management__search-input"
    />
    <FaSearch className="earnings-management__search-icon" />
  </div>

      {/* Export Button */}
      <div className="export-btn-container1">
             <button className="export-btn" onClick={exportToExcel}>
               <FaFileExcel className="export-icon" /> Export to Excel
             </button>
           </div>


  <div className="earnings-management__filter">
    {/* Year Filter */}
    <select
      value={selectedYear}
      onChange={handleYearFilterChange}
      className="earnings-management__filter-select"
    >
      <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
      <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
      <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
      <option value={new Date().getFullYear() - 3}>{new Date().getFullYear() - 3}</option>
      {/* Add more years as needed */}
    </select>

    {/* Month Filter */}
    <select
      value={selectedMonth}
      onChange={handleMonthFilterChange}
      className="earnings-management__filter-select"
    >
      <option value="All">All Months</option>
      <option value="January">January</option>
      <option value="February">February</option>
      <option value="March">March</option>
      <option value="April">April</option>
      <option value="May">May</option>
      <option value="June">June</option>
      <option value="July">July</option>
      <option value="August">August</option>
      <option value="September">September</option>
      <option value="October">October</option>
      <option value="November">November</option>
      <option value="December">December</option>
    </select>
    <FaFilter className="earnings-management__filter-icon" />
  </div>
</div>


        {/* Monthly Earnings Table */}
        <h3>Reporter Earnings and Views</h3>
        <table className="earnings-management__monthly-table">
          <thead>
            <tr>
              <th>Reporter ID</th>
              <th>Total Views</th>
              <th>Earnings (INR)</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="4">{error}</td>
              </tr>
            ) : filteredData.length > 0 ? (
              filteredData.map((data, index) => (
                <tr key={index}>
                  <td>{data.reporterId}</td>
                  <td>{data.totalViews}</td>
                  <td>₹ {data.earnings}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No data available for the selected filter.</td>
              </tr>
            )}
          </tbody>  
        </table>
      </div>
    </div>
    
  );
};

export default EarningsManagement;
